<template>

  <cc-modal :show="showModal">
    <div class="float-right">
      <button type="button" class="btn btn-secondary" @click="showModal = false">Cancel</button>
      <button type="button" class="btn btn-primary">Save</button>
    </div>
  </cc-modal>

</template>

<script>

  import CcModal from "./Modal";

  export default {
    components: { CcModal },
    name: "ModalManager",
    data() {
      return {
        showModal: false
      }
    },
    methods: {
      init(config, element, callback) {
        this.showModal = !this.showModal;
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/editor/base/ModalManager.vue